import { Skeleton } from '@/components/ui/skeleton';

const DEFAULT_FIELD_COUNT = 6;

interface FormSkeletonProps {
  fieldCount?: number;
}

export function FormSkeleton({ fieldCount = DEFAULT_FIELD_COUNT }: FormSkeletonProps) {
  const fieldKeys = Array.from({ length: fieldCount }, (_, field) => `skeleton-field-${field}`);

  return (
    <div className="flex flex-col gap-5" aria-busy="true">
      <section className="rounded-xl border bg-card p-5 shadow-sm">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {fieldKeys.map((fieldKey) => (
            <div key={fieldKey} className="flex flex-col gap-2">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-9 w-full" />
            </div>
          ))}
        </div>
      </section>
      <div className="flex justify-end gap-2">
        <Skeleton className="h-9 w-20" />
        <Skeleton className="h-9 w-28" />
      </div>
    </div>
  );
}
